import * as React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

import Header from './header';
import Colophon from './colophon';

function Layout({ children }) {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          author
          authorUrl
        }
      }
    }
  `);

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center">
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <main className="flex w-full flex-grow flex-col items-center justify-start bg-background">
        {children}
      </main>
      <Colophon
        siteTitle={data.site.siteMetadata?.title || `Title`}
        siteAuthor={data.site.siteMetadata?.author}
        siteAuthorUrl={data.site.siteMetadata?.authorUrl}
      />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
